import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { FeedbackProcesso } from '../models/feedback-processo.model';
import { FeedbackProcessoRequest } from '../models/feedback-processo-request.model';
import { FeedbackReferencia } from '../models/feedback-referencia.model';
import { ResponsavelReferencia } from '../models/responsavel-referencia.model';
import { EnviarFeedbackAawebRequest } from '../models/enviar-feedback-aaweb-request.model';
import { PaginatedResponse, PaginationParams } from '../../../core/shared/models/pagination.model';
import { FeedbackListParams } from '../models/feedback-list-params.model';

export const FEEDBACK_PROCESSO_REPOSITORY = new InjectionToken<FeedbackProcessoRepository>('FeedbackProcessoRepository');

export interface FeedbackProcessoRepository {
  listarFeedbacksProcesso(params: FeedbackListParams): Observable<PaginatedResponse<FeedbackProcesso>>;
  buscarFeedbackProcessoPorId(idFeedback: number): Observable<FeedbackProcesso>;
  criarFeedbackProcesso(payload: FeedbackProcessoRequest): Observable<FeedbackProcesso>;
  editarFeedbackProcesso(idFeedback: number, payload: FeedbackProcessoRequest): Observable<FeedbackProcesso>;
  excluirFeedbackProcesso(idFeedback: number): Observable<void>;
  listarReferencisFeedback(): Observable<FeedbackReferencia[]>;
  listarReferenciasResponsavel(): Observable<ResponsavelReferencia[]>;
  enviarFeedbackAaweb(propostaId: string, eventoId: number, numSeqEtapa: number, payload: EnviarFeedbackAawebRequest): Observable<void>;
}

